import { Fragment, useState } from 'react';
import { Combobox, Transition } from '@headlessui/react';
import Button from '../../Atoms/Button';
import Dropdown from '../../Atoms/Dropdown';

const values = [
  { id: 1, value: 'Durward Reynolds' },
  { id: 2, value: 'Kenton Towne' },
  { id: 3, value: 'Therese Wunsch' },
  { id: 4, value: 'Benedict Kessler' },
  { id: 5, value: 'Katelyn Rohan' },
  { id: 6, value: 'Benedict Kessler' },
  { id: 7, value: 'Katelyn Rohan' },
  { id: 8, value: 'Benedict Kessler' },
  { id: 9, value: 'Katelyn Rohan' }
];

function InputCombo() {
  // https://headlessui.com/react/combobox
  // logic is incomplete, just placeholder for UI presentation
  const [selectedValue, setSelectedValue] = useState('');
  const [query, setQuery] = useState('');

  const filteredValues =
    query === ''
      ? values
      : values.filter((item) =>
          item.value
            .toLowerCase()
            .includes(query.toLowerCase())
        );
  return (
    <Combobox
      value={selectedValue}
      onChange={(value) => setSelectedValue(value)}
    >
      <div className="relative rounded-xl border-2 border-sl-blue border-opacity-10 bg-white @2xl:rounded-none @2xl:border-opacity-0">
        <Combobox.Button as="div">
          <Combobox.Input
            placeholder="What kind of job are you looking for?"
            onChange={(event) =>
              setQuery(event.target.value)
            }
            className="w-full rounded-xl py-2.5 px-3 font-circular text-base font-normal text-sl-blue placeholder-sl-blue placeholder-opacity-25 placeholder:transition-colors focus:placeholder-opacity-50 focus:outline-none @sm:px-5 @2xl:py-1"
          />
        </Combobox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          enter="transition ease-in duration-100"
          enterFrom="opacity-0 -transform-y-3"
          enterTo="opacity-100 transform-y-0"
          leaveFrom="opacity-100 transform-y-0"
          leaveTo="opacity-0 -transform-y-3"
          afterLeave={() => setQuery('')}
        >
          <Combobox.Options className="absolute z-50 max-h-40 w-full overflow-auto rounded-md bg-white text-left text-sm text-sl-blue text-opacity-60 shadow-lg focus:outline-none @2xl:mt-2">
            {filteredValues.map((item) => (
              <Combobox.Option
                key={item.id}
                value={item.value}
                className="bg-white"
              >
                {({ active, selected }) => (
                  <span
                    className={`block cursor-pointer py-1 px-3 ${
                      active || selected
                        ? 'bg-sl-indigo bg-opacity-10 text-opacity-100'
                        : 'text-opacity-75'
                    }`}
                  >
                    {item.value}
                  </span>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        </Transition>
      </div>
    </Combobox>
  );
}

function FormVacationSearch() {
  return (
    <form action="#!" className="@container">
      <div className="relative flex flex-col gap-y-3 rounded-xl border-2 border-transparent bg-transparent @2xl:mb-7 @2xl:flex-row @2xl:border-sl-blue @2xl:border-opacity-10 @2xl:bg-white @2xl:py-1.5">
        <div className="flex flex-1 flex-col gap-y-3 @2xl:flex-row">
          <div className="border-sl-blue border-opacity-10 @2xl:w-[52%] @2xl:border-r-2">
            <InputCombo />
          </div>
          <div className="flex @2xl:w-[48%]">
            <div className="flex flex-1 items-center rounded-xl border-2 border-sl-blue border-opacity-10 bg-white pl-3 pr-0 @sm:pl-5 @2xl:rounded-none @2xl:border-opacity-0 @2xl:pr-[58px]">
              <input
                className="w-full py-2.5 pr-3 font-circular text-base font-normal text-sl-blue placeholder-sl-blue placeholder-opacity-25 placeholder:transition-colors focus:placeholder-opacity-50 focus:outline-none @2xl:py-1"
                type="text"
                placeholder="Postcode of plaats"
              />
              <Dropdown
                bordered={false}
                shadow={false}
                postfixClass="text-[8px]"
                postfix=" KM"
                className="!h-[32px] shrink-0 basis-[95px]"
                data={[
                  {
                    id: '1',
                    label: '0',
                    value: 0
                  },
                  {
                    id: '2',
                    label: '5',
                    value: 5
                  },
                  {
                    id: '3',
                    label: '20',
                    value: 10
                  },
                  {
                    id: '4',
                    label: '30',
                    value: 30,
                    selected: true
                  }
                ]}
              />
            </div>
          </div>
        </div>
        <Button
          color="secondary"
          iconName="search"
          className="absolute -right-[2px] -top-[2px] -bottom-[2px] hidden w-[52px] @2xl:block"
          shadow
        />
        <Button
          color="secondary"
          text="Vacatures zoeken"
          className="@2xl:hidden"
          shadow
        />
      </div>
    </form>
  );
}

export default FormVacationSearch;
